var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleLayout',{attrs:{"color":"#ea6935","title":"新手入门","data":_vm.textData}})}
var staticRenderFns = []

export { render, staticRenderFns }